import React from "react";
import { useLocation } from "react-router-dom";
import UserDropdown from "components/Dropdowns/UserDropdown.js";

/* Map path segments to human-readable page titles */
const PAGE_TITLES = {
  brands:               "Brands",
  retailer:             "Retailer Types",
  products:             "Products",
  inventory:            "Inventory",
  schemes:              "Schemes",
  schemesv2:            "Schemes V2",
  nlc:                  "NLC",
  "nlc-v2":             "NLC V2",
  nlcCalculator:        "NLC Calculator",
  "price-drop":         "Price Drop",
  posts:                "Posts",
  share:                "Share",
  files:                "Files",
  states:               "States",
  district:             "District",
  users:                "Users",
  groups:               "Groups",
  subscriptions:        "Subscriptions",
  bulkSubscription:     "Bulk Subscription",
  totp:                 "TOTP",
  notifications:        "Notifications",
  "notification-topics":"Notification Topics",
  whatsapp:             "WhatsApp",
  connect:              "Connect",
  analytics:            "Analytics",
  myDukanhsn:           "HSN",
  myDukanbrands:        "Growbiz Brands",
  myDukanproducts:      "Growbiz Products",
  myDukanpricedrop:     "Growbiz Price Drop",
  myDukanblocknunblock: "Block / Unblock",
  mydukanSubscriptions: "Growbiz Subscriptions",
  mydukanUsers:         "Growbiz Users",
};

export default function AdminNavbar() {
  const location = useLocation();
  const segment  = location.pathname.split("/").filter(Boolean).pop();
  const pageTitle = PAGE_TITLES[segment] ?? "Dashboard";

  return (
    <nav className="admin-topbar hidden md:flex justify-between">
      {/* Page title */}
      <div className="flex items-center gap-2">
        <h1 className="text-base font-semibold" style={{ color: "var(--color-text-primary)" }}>
          {pageTitle}
        </h1>
      </div>

      {/* Right side actions */}
      <div className="flex items-center gap-3">
        <UserDropdown />
      </div>
    </nav>
  );
}
